<template>
    <div>
        <loading :active.sync="loader" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="input-group mt-n2">
            <input id="password" :type="showpass1 ? 'text': 'password'" class="form-control" v-model="password" name="password" required autocomplete="new-password" placeholder="Password">
            <div class="input-group-append">
                <a href="javascript:void(0)" class="btn btn-default" @click="showpass1 = !showpass1"><i :class="showpass1 ? 'fa fa-eye':'fa fa-eye-slash'" aria-hidden="true"></i></a>
            </div>
        </div>
        <p class="card-text" style="margin-bottom:5px; font-size:15px;">
            The password must contain the following:
        </p>
        <div class="ml-2 mb-2 fs-12">
            <p class="mb-0" v-for="(req, index) in password_req" :key="index">
                <span style="font-size:13px;" :class="{'text-success': $v.password[req.key] && password}">
                    <feather :type="iconCheck($v.password[req.key] && password)" stroke-width="2" size="14px"></feather> {{req.label}}
                </span>
            </p>
        </div>
    </div>
</template>

<script>



</script>

<script>
    import VueFeather from 'vue-feather';
    Vue.use(VueFeather);
    import {
        required,
        minLength,
        requiredIf,
        helpers,
        sameAs
    } from "vuelidate/lib/validators";
    const lower = helpers.regex('lower', /[a-z]/);
    const upper = helpers.regex('upper', /[A-Z]/);
    const num = helpers.regex('num', /\d/);
    const special = helpers.regex('special', /[!@#$%^&*_\-]/);

    export default {
        data() {
            return {
                loader: true,
                showpass1: false,
                email: this.$route.query.email,
                password: null,

                password_req: [{
                        key: 'lower',
                        label: 'at least 1 lowercase character (a-z)'
                    },
                    {
                        key: 'upper',
                        label: 'at least 1 uppercase character (A-Z)'
                    },
                    {
                        key: 'num',
                        label: 'at least 1 number (0-9)'
                    },
                    {
                        key: 'special',
                        label: 'at least 1 special character (!@#$%^&*_-)'
                    },
                    {
                        key: 'minLength',
                        label: 'at least 6 characters'
                    }
                ],

            }
        },
        validations: {
            password: {
                required,
                lower,
                upper,
                num,
                special,
                minLength: minLength(6)
            },

        },

        created() {},
        methods: {
            iconCheck(e) {
                return e ? 'check' : 'alert-circle';
            },
        },
        computed: {

        },
        mounted() {
            setTimeout(() => {
                this.loader = false;
            }, 333);
        }

    }
</script>